import { BhImage } from 'models/BhImage';
import { INotifyLink } from 'models/INotifyLink';
import { IMenuItem } from 'models/IMenuItem';
import { NotifyLink } from 'components/Shared/NotifyLink';
import Image from 'components/Shared/Image';
import styles from './styles.scss';
import { format, NO_ELEMENT } from 'utils';
import cn from 'classnames';
import { Block } from 'components/Shared/Layout';
import { AppearanceTypes } from 'components/Shared/Layout/base';

interface CategoryLinksProps {
  appearance?: AppearanceTypes;
  className?: string;
  title?: string;
  image?: BhImage;
  links: (INotifyLink | IMenuItem)[];
  showAllCategories?: boolean;
  showAllCategoriesText?: string;
  numberOfCategories?: number;
  categoryUrl?: string;
  hideLinksInMobile?: boolean;
  children?: (link: INotifyLink | IMenuItem) => JSX.Element;
}

const SECTION_IMAGE_WIDTH = 120;
const SECTION_IMAGE_HEIGHT = 120;

export const isMenuItem = (link: INotifyLink | IMenuItem): link is IMenuItem =>
  (link as IMenuItem).id !== undefined;

const renderLink = (link: INotifyLink) => (
  <li className={styles.linkItem} key={link.title}>
    <NotifyLink ticket={link.ticket} url={link.url}>
      {link.title}
      {isMenuItem(link) && !!link.productCount && link.productCount > 0 && (
        <span>{link.productCount}</span>
      )}
    </NotifyLink>
  </li>
);

const CategoryImage = ({
  image,
  categoryUrl,
  title,
  appearance
}: Pick<CategoryLinksProps, 'image' | 'categoryUrl' | 'title' | 'appearance'>) =>
  image ? (
    <div
      className={cn(styles.imageWrapper, {
        [styles.hideImageInMobile]: appearance === 'secondary'
      })}
    >
      <a href={categoryUrl}>
        <Image
          wrapperStyle={{ width: '100%' }}
          paddingBottom
          {...image}
          height={SECTION_IMAGE_HEIGHT}
          width={SECTION_IMAGE_WIDTH}
          alt={title}
        />
      </a>
    </div>
  ) : (
    NO_ELEMENT
  );

export const CategoryLinks = ({
  image,
  className,
  appearance = 'primary',
  title,
  children,
  categoryUrl,
  links,
  showAllCategories,
  showAllCategoriesText,
  numberOfCategories,
  hideLinksInMobile
}: CategoryLinksProps) => (
  <Block padding="none" appearance={appearance} className={cn(styles.categoryLinks, className)}>
    <CategoryImage {...{ image, title, categoryUrl, appearance }} />
    <div>
      {title && categoryUrl && (
        <h3>
          <a href={categoryUrl} dangerouslySetInnerHTML={{ __html: title }} />
        </h3>
      )}
      {title && !categoryUrl && <h3>{title}</h3>}
      <ul className={cn(styles.links, { [styles.hideInMobile]: hideLinksInMobile })}>
        {links.length > 0 ? (
          links.map(children ? children : renderLink)
        ) : (
          <li className={styles.linkItem}>
            <a href={categoryUrl} dangerouslySetInnerHTML={{ __html: title || '' }} />
          </li>
        )}
      </ul>
      {showAllCategories && showAllCategoriesText && (
        <a
          className={cn(styles.showAll, { [styles.hideInMobile]: hideLinksInMobile })}
          href={categoryUrl}
        >
          {format(showAllCategoriesText, numberOfCategories)}
        </a>
      )}
    </div>
  </Block>
);
